var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recruit_entry_icon3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.303,
    height: 59.026,
    viewBox: "0 0 59.303 59.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184261",
    "data-name": "\\uADF8\\uB8F9 184261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132151",
    "data-name": "\\uD328\\uC2A4 132151",
    d: "M437.413,420.081a4.488,4.488,0,0,0-6.347-.067l-31.623,30.964a4.488,4.488,0,0,0-.068,6.347l18,18.38a4.489,4.489,0,0,0,6.347.068l31.624-30.965a4.488,4.488,0,0,0,.067-6.347Z",
    transform: "translate(-397.742 -418.38)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132152",
    "data-name": "\\uD328\\uC2A4 132152",
    d: "M437.425,419.59a4.85,4.85,0,0,0-6.85-.073l-31.624,30.965a4.849,4.849,0,0,0-.072,6.85l18,18.38a4.851,4.851,0,0,0,6.85.073l31.623-30.965a4.849,4.849,0,0,0,.072-6.85Zm17.427,24.721.249.254-.249-.254-31.623,30.964a4.137,4.137,0,0,1-5.845-.061l-18-18.38a4.138,4.138,0,0,1,.061-5.845l31.624-30.964a4.137,4.137,0,0,1,5.844.062l18,18.379A4.138,4.138,0,0,1,454.852,444.311Z",
    transform: "translate(-397.499 -418.137)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184262",
    "data-name": "\\uADF8\\uB8F9 184262",
    transform: "translate(2.23 1.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132153",
    "data-name": "\\uD328\\uC2A4 132153",
    d: "M438.959,420.589l-.508.5.965.985a5.615,5.615,0,0,1,1.468,5.2l-5.449,23.845a5.65,5.65,0,0,1-4.346,4.264l-24.026,5a5.613,5.613,0,0,1-5.177-1.575l-.113-.116-.51.5.114.116a6.313,6.313,0,0,0,4.523,1.909,6.415,6.415,0,0,0,1.308-.135l24.025-5a6.363,6.363,0,0,0,4.894-4.8l5.449-23.845a6.324,6.324,0,0,0-1.653-5.856Z",
    transform: "translate(-401.263 -420.589)",
    fill: "#111"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184263",
    "data-name": "\\uADF8\\uB8F9 184263",
    transform: "translate(40.243 15.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154181",
    "data-name": "\\uC0AC\\uAC01\\uD615 154181",
    width: 0.712,
    height: 14.249,
    transform: "matrix(0.043, -0.999, 0.999, 0.043, 0, 0.711)",
    fill: "#111"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184264",
    "data-name": "\\uADF8\\uB8F9 184264",
    transform: "translate(15.684 39.753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154182",
    "data-name": "\\uC0AC\\uAC01\\uD615 154182",
    width: 0.711,
    height: 14.248,
    transform: "translate(0 0.016) rotate(-1.252)",
    fill: "#111"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184265",
    "data-name": "\\uADF8\\uB8F9 184265",
    transform: "translate(19.901 46.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154183",
    "data-name": "\\uC0AC\\uAC01\\uD615 154183",
    width: 8.278,
    height: 5.064,
    transform: "translate(0 5.791) rotate(-44.394)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184268",
    "data-name": "\\uADF8\\uB8F9 184268",
    transform: "translate(23.529 42.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184266",
    "data-name": "\\uADF8\\uB8F9 184266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132154",
    "data-name": "\\uD328\\uC2A4 132154",
    d: "M444.614,491.07a2.188,2.188,0,0,0-1.831,1.792,1.483,1.483,0,0,1-1.273,1.246,2.185,2.185,0,0,0-1.829,1.79,1.377,1.377,0,0,1-.427.834,1.392,1.392,0,0,1-.843.41,2.09,2.09,0,0,0-1.2.6l.5.509a1.389,1.389,0,0,1,.843-.41,2.184,2.184,0,0,0,1.828-1.789,1.479,1.479,0,0,1,1.27-1.244,2.188,2.188,0,0,0,1.83-1.791,1.487,1.487,0,0,1,1.273-1.248,2.088,2.088,0,0,0,1.2-.6l-.5-.508A1.394,1.394,0,0,1,444.614,491.07Z",
    transform: "translate(-437.209 -490.659)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184267",
    "data-name": "\\uADF8\\uB8F9 184267",
    transform: "translate(1.268 1.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132155",
    "data-name": "\\uD328\\uC2A4 132155",
    d: "M446.754,493.256a2.189,2.189,0,0,0-1.83,1.792,1.48,1.48,0,0,1-1.272,1.245,2.183,2.183,0,0,0-1.828,1.791,1.479,1.479,0,0,1-1.271,1.244,2.085,2.085,0,0,0-1.2.6l.5.508a1.4,1.4,0,0,1,.843-.409,2.186,2.186,0,0,0,1.829-1.791,1.474,1.474,0,0,1,1.27-1.243,2.182,2.182,0,0,0,1.829-1.792,1.484,1.484,0,0,1,1.273-1.247,2.1,2.1,0,0,0,1.206-.6l-.5-.508A1.393,1.393,0,0,1,446.754,493.256Z",
    transform: "translate(-439.349 -492.845)",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon3);
export default __webpack_public_path__ + "static/media/recruit_entry_icon3.899082f5cd9ee7530ffa692682e1439f.svg";
export { ForwardRef as ReactComponent };